import { useState, useEffect, useRef } from 'react';
import sceneConfig from '../config/sceneConfig';

/**
 * Hook that returns the current responsive breakpoint name.
 * Only updates when the breakpoint actually changes (not on every resize).
 * 
 * @returns {string} The current breakpoint name: 'mobile', 'tablet', or 'desktop'
 */
export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState(() => {
    // Calculate initial breakpoint
    const width = window.innerWidth;
    const height = window.innerHeight;
    const breakpoints = sceneConfig.cameraOffsets.breakpoints;
    
    if (width < breakpoints.tablet.minWidth || height < breakpoints.tablet.minHeight) {
      return 'mobile';
    } else if (width < breakpoints.desktop.minWidth || height < breakpoints.desktop.minHeight) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  });

  const breakpointRef = useRef(breakpoint);

  // Keep ref in sync with state
  useEffect(() => {
    breakpointRef.current = breakpoint;
  }, [breakpoint]);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const breakpoints = sceneConfig.cameraOffsets.breakpoints;
      
      let newBreakpoint;
      if (width < breakpoints.tablet.minWidth || height < breakpoints.tablet.minHeight) {
        newBreakpoint = 'mobile';
      } else if (width < breakpoints.desktop.minWidth || height < breakpoints.desktop.minHeight) {
        newBreakpoint = 'tablet';
      } else {
        newBreakpoint = 'desktop';
      }

      // Only update state if breakpoint actually changed
      if (newBreakpoint !== breakpointRef.current) {
        setBreakpoint(newBreakpoint);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoint;
};

